import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { vars } from '@machobear/design-system/css'
import { createModal } from '@/components/modalize/mui'
import { SuccessIcon } from '@/components/icons'
import { fontWeights, fontSizes, breakpoints } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  gap: 20px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 15% 40px;
  }
`

const Topper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const Title = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
  line-height: 32px;
  text-align: center;
`
const Subtitle = styled.div`
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.regular};
  line-height: 24px;
  text-align: center;
  color: ${vars.foregroundColor.secondary};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    text-align: left;
  }
`

const PaymentConfirmationModal = ({ invoiceNumber = '' }) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Topper>
        <SuccessIcon />
      </Topper>
      <Main>
        <TitleSection>
          <Title>{t('l.promotions.view.youre_all_set.title', 'You’re all set!')}</Title>
          <Subtitle>
            <Trans i18nKey="l.promotions.view.youre_all_set.text" invoiceNumber={invoiceNumber}>
              Confirmation details with invoice #{{ invoiceNumber }} have been sent to your email.
              Please allow up to 30 seconds for the credits to be applied to your account.
            </Trans>
          </Subtitle>
          <Subtitle>
            <Trans i18nKey="l.promotions.view.youre_all_set.text_3">
              If you have any questions, please contact{' '}
              <a href="mailto:support@liv.rent" target="_blank" rel="noopener noreferrer">
                support@liv.rent
              </a>
              .
            </Trans>
          </Subtitle>
        </TitleSection>
      </Main>
    </Wrapper>
  )
}

export const showPaymentConfirmationModal = createModal(PaymentConfirmationModal, {
  width: 'auto',
  maxWidth: '336px',
  showBackground: false
})
